import { render, staticRenderFns } from "./OperationsSettingsForm.vue?vue&type=template&id=3505409e"
import script from "./OperationsSettingsForm.vue?vue&type=script&lang=js"
export * from "./OperationsSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports